import React from 'react';
import MarketSelector from '../../../MarketSelector';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import LanguageSelector from '../../../LanguageSelectorNew';
import { useHistory } from 'react-router-dom';
import styles from './LeftPanel.module.css';
import SearchGrid from './SearchGrid';
import PinnedPanel from './PinnedPanel';
import { AppUtils } from '@gscope-mfe/app-bridge';
import { useTranslation } from 'react-i18next';
import ChatbotWidget from '../Widgets/ChatbotWidget';
import ResetChatbot from '../Buttons/ResetChatbot';

const { OutlinedInput, InputAdornment, Modal, Box, Button, makeStyles } = MaterialUiCore;
const useStyles = makeStyles(() => ({
    searchInput: {
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'solid 1px rgba(0, 0, 0, 0.5)',
        },
        '& .MuiInputBase-input': {
            paddingBottom: '21px',
        },
    },
}));
const LeftPanel = ({
    title,
    titleKey,
    leftPanelChild,
    LeftPanelShowToggle,
    showLeftPanel,
    bucketsLookup,
    pinnedBuckets,
    langPref,
    unpinFunc,
    pinModuleFunc,
    showPanelWithChild,
    unPinAll,
    supportedlngs,
}) => {
    const classesLocal = useStyles();
    let history = useHistory();
    const [leftNavTitle, setLeftNavTitle] = React.useState({
        navKey: titleKey,
        navValue: title,
    });
    const [prevArray, setPrevArray] = React.useState([bucketsLookup]);
    const [titleArray, setTitleArray] = React.useState([]);
    const [searchMatches, setSearchMatches] = React.useState({});
    const [searching, setSearching] = React.useState(false);
    const [searchResultsClick, setSearchResultsClick] = React.useState(false);
    const [searchString, setSearchString] = React.useState('');
    const [pinUnpinPath, setPinUnpinPath] = React.useState({ path: '' });
    const [clearAllModal, setClearAllModal] = React.useState(false);
    const { currentPage } = AppUtils.get();
    const { t } = useTranslation('commonLang');
    const leftPanelChildrenModules = React.useRef();
    const showChildOfBucketLeftPanel = function (bucket) {
        if (bucket.pages) {
            setLeftNavTitle({
                navKey: bucket.navKey,
                navValue: bucket.name,
            });
            let titleArrayCopy = [...titleArray];
            titleArrayCopy.push(bucket);
            setTitleArray(titleArrayCopy);
            let prevArrayCopy = [...prevArray];
            prevArrayCopy.push(bucket.pages);
            setPrevArray(prevArrayCopy);
        } else {
            LeftPanelShowToggle();
            if (history.location.pathname != bucket.route) history.push(bucket.route);
        }
    };

    const goToPrevLevel = () => {
        let prevArrayCopy = [...prevArray];
        prevArrayCopy.pop();
        let titleArrayCopy = [...titleArray];
        titleArrayCopy.pop();
        setTitleArray(titleArrayCopy);
        setLeftNavTitle({
            navKey: titleArrayCopy[titleArrayCopy.length - 1].navKey,
            navValue: titleArrayCopy[titleArrayCopy.length - 1].name,
        });
        setPrevArray(prevArrayCopy);
        //Get back to show search results once navigated out of bucket view
        if (searchResultsClick && prevArrayCopy.length == 1) {
            setSearchResultsClick(false);
        }
    };
    const clearSearchField = () => {
        searchStringChange();
    };
    const navigateBackToCurrentPage = (buckets, pageKeys, atBucketLevel) => {
        let titleArrayCopy = [];
        let prevArrayCopy = [buckets];
        titleArrayCopy.push({ name: 'Modules', notBucket: true, navKey: 'modules' });

        if (atBucketLevel) {
            for (let i = 0; i < pageKeys.length - 1; i++) {
                titleArrayCopy.push(buckets[pageKeys[i]]);
                prevArrayCopy.push(buckets[pageKeys[i]]['pages']);
                buckets = buckets[pageKeys[i]]['pages'];
            }
        } else {
            for (let i = 0; i < pageKeys.length - 1; i++) {
                titleArrayCopy.push(buckets[pageKeys[i]]);
                console.log(prevArrayCopy);
                prevArrayCopy.push(buckets[pageKeys[i]]['pages']);
                buckets = buckets[pageKeys[i]]['pages'];
            }
        }
        setTitleArray(titleArrayCopy);
        setPrevArray(prevArrayCopy);
    };

    const unpinTheModule = (bucket, AtBucketLevel) => {
        let path = bucket.pinPath;
        setPinUnpinPath({ path: path, AtBucketLevel: AtBucketLevel });
        unpinFunc(bucket);
    };

    const pinTheModule = (bucket, AtBucketLevel) => {
        setPinUnpinPath({ path: bucket.pinPath, AtBucketLevel: AtBucketLevel });
        pinModuleFunc(bucket);
    };

    const checkForSearchMatch = (returnResult, val, bucketsLookupObj) => {
        let flag = 0;
        let matchingBuckets = {};
        let recResult = {};
        Object.keys(bucketsLookupObj).forEach((bucket) => {
            recResult = {};
            let matchingPages = {};
            let bucketNameFound = false;
            let bucketName =
                t(bucketsLookupObj[bucket].navKey) == bucketsLookupObj[bucket].navKey
                    ? bucketsLookupObj[bucket].name
                    : t(bucketsLookupObj[bucket].navKey);

            if (bucketName.toLowerCase().includes(val.toLowerCase())) {
                bucketNameFound = true;
                flag = 1;
                matchingBuckets[bucket] = { ...bucketsLookupObj[bucket] };
            }

            if (
                Object.keys(bucketsLookupObj) &&
                Object.keys(bucketsLookupObj[bucket]) &&
                Object.prototype.hasOwnProperty.call(bucketsLookupObj[bucket], 'pages')
            ) {
                Object.keys(bucketsLookupObj[bucket].pages).forEach((page) => {
                    recResult = {};
                    let name =
                        t(bucketsLookupObj[bucket].pages[page].navKey) == bucketsLookupObj[bucket].pages[page].navKey
                            ? bucketsLookupObj[bucket].pages[page].name
                            : t(bucketsLookupObj[bucket].pages[page].navKey);

                    if (name) {
                        name = name.toLowerCase();

                        if (name.includes(val.toLowerCase())) {
                            matchingPages[page] = { ...bucketsLookupObj[bucket].pages[page] };
                            flag = 1;
                        }
                    }

                    if (Object.prototype.hasOwnProperty.call(bucketsLookupObj[bucket].pages[page], 'pages')) {
                        let recObject = {};
                        recObject[page] = { ...bucketsLookupObj[bucket].pages[page] };
                        recResult = checkForSearchMatch(returnResult, val, recObject);

                        if (recResult.flag) {
                            matchingPages[page] = recResult.result[page];
                        }
                    }
                });
            }

            if (
                Object.keys(matchingPages).length ||
                (Object.keys(recResult).length && Object.keys(recResult.result).length && recResult.flag) ||
                bucketNameFound
            ) {
                matchingBuckets[bucket] = { ...bucketsLookupObj[bucket] };
                matchingBuckets[bucket].searchPages = matchingPages;
            }
            returnResult = { ...returnResult, ...matchingBuckets };
        });

        let finalRet = {
            result: returnResult,
            flag: flag,
        };
        return finalRet;
    };

    const searchStringChange = (event) => {
        if (!event || !event.target || !event.target.value || event.target.value.trim() == '') {
            setSearchMatches({});
            setSearchString('');
            return;
        }

        const val = event.target.value;
        setSearchString(val);
        let returnResult = {};
        let ans = checkForSearchMatch(returnResult, val, bucketsLookup);
        setSearchMatches(ans.result);
    };
    const unPinAllConfirm = () => {
        setClearAllModal(true);
    };

    const clearAllCancelHandler = () => {
        setClearAllModal(false);
    };
    const clearAllHandler = () => {
        setClearAllModal(false);
        unPinAll();
    };
    const checkBucketDeeply = (bucket, titleCp, prevCp) => {
        for (let page in bucket.pages) {
            if (bucket.pages[page].name == currentPage.name && bucket.pages[page].route == currentPage.route) {
                let pinPath = bucket.pages[page].pinPath.split('.');
                let bucketsCp = { ...bucketsLookup[pinPath[1]] };

                for (let i = 1; i < pinPath.length - 1; i++) {
                    titleCp.push(bucketsCp);
                    prevCp.push(bucketsCp.pages);
                    bucketsCp = bucketsCp['pages'][pinPath[i + 1]];
                }

                let ob = { prevCpReturn: prevCp, titleCpReturn: titleCp };
                return ob;
            } else {
                //Check for match in the child pages if any
                if (Object.prototype.hasOwnProperty.call(bucket.pages[page], 'pages')) {
                    let ob2 = checkBucketDeeply(bucket.pages[page], titleCp, prevCp);
                    if (ob2) return ob2;
                }
            }
        }
    };
    const navigateToCurrentContext = (buckets, titleCp, prevCp) => {
        let obj = {};
        for (let bucket in buckets) {
            obj = checkBucketDeeply(buckets[bucket], titleCp, prevCp);
            if (obj && obj.prevCpReturn.length > 0 && obj.titleCpReturn.length > 0) {
                break;
            }
        }
        setPrevArray(obj.prevCpReturn);
        setTitleArray(obj.titleCpReturn);
    };
    React.useEffect(() => {
        if (title == 'Modules') setTitleArray([{ name: 'Modules', notBucket: true, navKey: 'modules' }]);
        setPrevArray([bucketsLookup]);
        setLeftNavTitle({
            navKey: titleKey,
            navValue: title,
        });
    }, [bucketsLookup]);

    React.useEffect(() => {
        if (bucketsLookup) {
            if (searching || !searchResultsClick) {
                let ans = checkForSearchMatch({}, searchString, bucketsLookup);
                setSearchMatches(ans.result);
            }
        }
    }, [bucketsLookup]);

    React.useEffect(() => {
        if (pinUnpinPath)
            if (pinUnpinPath.path && pinUnpinPath.path != '' && bucketsLookup) {
                let pageKeys = pinUnpinPath.path.split('.');
                pageKeys.splice(0, 1);
                let bucketsCp = JSON.parse(JSON.stringify(bucketsLookup));
                navigateBackToCurrentPage(bucketsCp, pageKeys, pinUnpinPath.AtBucketLevel);
            }
    }, [bucketsLookup, pinUnpinPath]);

    React.useEffect(() => {
        if (title != 'Modules') {
            setTitleArray([]);
            setSearchString('');
            setSearching(false);
            setSearchMatches({});
            setSearchResultsClick(false);
            setPrevArray([]);
            if (pinUnpinPath && pinUnpinPath.path) {
                setPinUnpinPath({ path: '' });
            }
        } else if (title == 'Modules' && !pinUnpinPath.path) {
            if (Object.keys(currentPage).length > 0) {
                let titleArrayCopy = [{ name: title, notBucket: true, navKey: titleKey }];
                let prevArrayCopy = [bucketsLookup];
                navigateToCurrentContext(bucketsLookup, titleArrayCopy, prevArrayCopy);
            } else {
                setTitleArray([{ name: title, notBucket: true, navKey: titleKey }]);
                setPrevArray([bucketsLookup]);
            }
        }
        setLeftNavTitle({
            navKey: titleKey,
            navValue: title,
        });
    }, [title, currentPage]);

    React.useEffect(() => {
        if (!showLeftPanel) {
            setSearchString('');
            setSearching(false);
            setSearchResultsClick(false);
            setTitleArray([]);
            setPrevArray([]);
            setSearchMatches({});
        }
    }, [showLeftPanel]);

    React.useEffect(() => {
        if (titleArray.length > 0) {
            setLeftNavTitle({
                navKey: titleArray[titleArray.length - 1].navKey,
                navValue: titleArray[titleArray.length - 1].name,
            });
        }
    }, [titleArray]);
    React.useEffect(() => {
        if (leftPanelChildrenModules.current) {
            leftPanelChildrenModules.current.scrollTop = 0;
        }
    }, [prevArray]);

    return (
        <React.Fragment>
            <div
                data-testid="left-panel"
                style={showLeftPanel ? { left: '80px' } : { left: '-300px' }}
                className={styles.panel}
            >
                <div className={styles.mobilePanel}></div>
                <div className={styles.title}>
                    <div className={styles.titleContents} data-testid="Title-Left">
                        {prevArray.length > 1 ? (
                            <React.Fragment>
                                <i
                                    style={{ marginRight: '16px' }}
                                    className={'icon-Back-Arrow-18 sct-icon' + ` ${styles['back-icon']}`}
                                    onClick={goToPrevLevel}
                                ></i>
                            </React.Fragment>
                        ) : (
                            ''
                        )}
                        {titleArray.length &&
                        titleArray[titleArray.length - 1]['pinned'] &&
                        !titleArray[titleArray.length - 1]['notBucket'] ? (
                            <i
                                onClick={() => {
                                    unpinTheModule(titleArray[titleArray.length - 1], true);
                                }}
                                data-testid="title-unpin-module"
                                style={{ marginRight: '8px' }}
                                className={'sct-icon icon-2111_unpinLatest ' + `${styles['page-icon']}`}
                            ></i>
                        ) : titleArray.length &&
                          !titleArray[titleArray.length - 1]['pinned'] &&
                          !titleArray[titleArray.length - 1]['notBucket'] ? (
                            <i
                                data-testid="title-pin-module"
                                style={{ marginRight: '8px' }}
                                className={'sct-icon icon-2111_pinLatest ' + `${styles['page-icon']}`}
                                onClick={() => pinTheModule(titleArray[titleArray.length - 1], true)}
                            ></i>
                        ) : (
                            ''
                        )}
                        {t(leftNavTitle.navKey) == leftNavTitle.navKey ? leftNavTitle.navValue : t(leftNavTitle.navKey)}
                        {leftPanelChild == 'chatbot' && <ResetChatbot></ResetChatbot>}
                    </div>
                    <div style={{ display: 'flex' }}>
                        {leftPanelChild == 'pin' ? (
                            <div style={{ marginRight: '16px' }}>
                                <button
                                    data-testid="clearAllOption"
                                    className={styles.clearPin}
                                    style={Object.keys(pinnedBuckets).length == 0 ? { cursor: 'not-allowed' } : {}}
                                    disabled={Object.keys(pinnedBuckets).length == 0}
                                    onClick={unPinAllConfirm}
                                >
                                    {t('clearAll')}
                                </button>
                            </div>
                        ) : (
                            ''
                        )}
                        <div id="close" onClick={LeftPanelShowToggle}>
                            <i
                                style={{ fontSize: '10px', cursor: 'pointer' }}
                                className="icon-10_CloseLatest sct-icon"
                            ></i>
                        </div>
                    </div>
                </div>
                <div id="childrenOfLeftPanel" className={styles.leftPanelChildren}>
                    {leftPanelChild == 'chatbot' ? (
                        <div style={{ width: '100%', height: '100%' }}>
                            <ChatbotWidget></ChatbotWidget>
                        </div>
                    ) : leftPanelChild == 'market' ? (
                        <MarketSelector data-testid="market-selector" LeftPanelShowToggle={LeftPanelShowToggle} />
                    ) : leftPanelChild == 'modules' ? (
                        <div style={{ height: 'inherit' }}>
                            {prevArray.length <= 1 ? (
                                <OutlinedInput
                                    className={`${styles['search-input']} ${classesLocal.searchInput}`}
                                    placeholder={t('search')}
                                    variant="filled"
                                    fullWidth
                                    autoComplete="off"
                                    data-testid="my-search-box"
                                    id="searchPagesInput"
                                    value={searchString}
                                    onKeyDown={() => setSearching(true)}
                                    onChange={searchStringChange}
                                    startAdornment={
                                        ((searchString && searchString.length > 0) || searching) && (
                                            <InputAdornment position="start">
                                                <i
                                                    data-testid="search-back"
                                                    className={`sct-icon icon-Arrow-Left-18 ${styles['back-icon']}`}
                                                    onClick={() => {
                                                        clearSearchField();
                                                        setSearching(false);
                                                    }}
                                                ></i>
                                            </InputAdornment>
                                        )
                                    }
                                    endAdornment={
                                        (searchString && searchString.length > 0) || searching ? (
                                            <InputAdornment position="end">
                                                <i
                                                    data-testid="search-cross"
                                                    className={`sct-icon ${styles['clear-icon']} icon-Remove-18`}
                                                    onClick={clearSearchField}
                                                ></i>
                                            </InputAdornment>
                                        ) : (
                                            <InputAdornment position="end">
                                                <i
                                                    data-testid="search-glass"
                                                    className={`sct-icon ${styles['clear-icon']} icon-14_searchLatest`}
                                                    onClick={clearSearchField}
                                                ></i>
                                            </InputAdornment>
                                        )
                                    }
                                />
                            ) : (
                                ''
                            )}
                            {!searching || searchResultsClick ? (
                                <div
                                    data-testid="panel-modules"
                                    ref={leftPanelChildrenModules}
                                    id="gscopeModulesSection"
                                    className={styles['gscope-modules']}
                                    style={{ height: 'inherit', overflowY: 'auto' }}
                                >
                                    {prevArray &&
                                        prevArray.length > 0 &&
                                        Object.keys(prevArray[prevArray.length - 1])
                                            .sort((a, b) => {
                                                if (
                                                    prevArray[prevArray.length - 1][a].name <
                                                    prevArray[prevArray.length - 1][b].name
                                                ) {
                                                    return -1;
                                                }
                                                if (
                                                    prevArray[prevArray.length - 1][a].name >
                                                    prevArray[prevArray.length - 1][b].name
                                                ) {
                                                    return 1;
                                                }
                                            })
                                            .map((bucket, index) => {
                                                return (
                                                    <div
                                                        data-testid="single-module"
                                                        onClick={() =>
                                                            showChildOfBucketLeftPanel(
                                                                prevArray[prevArray.length - 1][bucket],
                                                            )
                                                        }
                                                        key={index}
                                                        className={
                                                            prevArray[prevArray.length - 1][bucket].name ==
                                                            currentPage.name
                                                                ? `${styles['nav-item']} ${styles['highlighted-nav-item']}`
                                                                : `${styles['nav-item']}`
                                                        }
                                                    >
                                                        {prevArray.length > 1 ? (
                                                            !prevArray[prevArray.length - 1][bucket].pages ? (
                                                                prevArray[prevArray.length - 1][bucket].pinned ? (
                                                                    <i
                                                                        data-testid="single-module-unpin"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            unpinTheModule(
                                                                                prevArray[prevArray.length - 1][bucket],
                                                                                false,
                                                                            );
                                                                        }}
                                                                        className={
                                                                            'sct-icon icon-2111_unpinLatest ' +
                                                                            `${styles['page-icon']}`
                                                                        }
                                                                    ></i>
                                                                ) : (
                                                                    <i
                                                                        data-testid="single-module-pin"
                                                                        className={
                                                                            'sct-icon icon-2111_pinLatest ' +
                                                                            `${styles['page-icon']}`
                                                                        }
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            pinTheModule(
                                                                                prevArray[prevArray.length - 1][bucket],
                                                                                false,
                                                                            );
                                                                        }}
                                                                    ></i>
                                                                )
                                                            ) : prevArray[prevArray.length - 1][bucket].pinned ? (
                                                                <i
                                                                    data-testid="single-module-unpin"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        unpinTheModule(
                                                                            prevArray[prevArray.length - 1][bucket],
                                                                            true,
                                                                        );
                                                                    }}
                                                                    className={
                                                                        'sct-icon icon-2111_unpinLatest ' +
                                                                        `${styles['page-icon']}`
                                                                    }
                                                                ></i>
                                                            ) : (
                                                                <i
                                                                    data-testid="single-module-pin"
                                                                    className={
                                                                        'sct-icon icon-2111_pinLatest ' +
                                                                        `${styles['page-icon']}`
                                                                    }
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        pinTheModule(
                                                                            prevArray[prevArray.length - 1][bucket],
                                                                            true,
                                                                        );
                                                                    }}
                                                                ></i>
                                                            )
                                                        ) : (
                                                            ''
                                                        )}
                                                        <span className={styles['item-text']}>
                                                            {t(prevArray[prevArray.length - 1][bucket].navKey) ==
                                                            prevArray[prevArray.length - 1][bucket].navKey
                                                                ? prevArray[prevArray.length - 1][bucket].name
                                                                : t(prevArray[prevArray.length - 1][bucket].navKey)}
                                                        </span>
                                                        {prevArray[prevArray.length - 1][bucket]['pages'] && (
                                                            <i
                                                                style={{ fontSize: '16px' }}
                                                                className="sct-icon icon-ChevronRightLatestLD3"
                                                            ></i>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                </div>
                            ) : (
                                <div style={{ height: '95%', overflowY: 'auto' }}>
                                    <SearchGrid
                                        data-testid="search-panel"
                                        setSearchResultsClick={setSearchResultsClick}
                                        showChildOfBucketLeftPanel={showChildOfBucketLeftPanel}
                                        searchMatches={searchMatches}
                                        unpinFunc={unpinFunc}
                                        pinFunc={pinModuleFunc}
                                    />
                                </div>
                            )}
                        </div>
                    ) : leftPanelChild == 'pin' ? (
                        <PinnedPanel
                            data-testid="pin-panel"
                            unpin={unpinFunc}
                            pinnedBuckets={pinnedBuckets}
                            showPanelWithChild={showPanelWithChild}
                        />
                    ) : (
                        <LanguageSelector
                            LeftPanelShowToggle={LeftPanelShowToggle}
                            langPref={langPref}
                            supportedlngs={supportedlngs}
                        />
                    )}
                </div>
            </div>
            {clearAllModal && (
                <Modal
                    open={clearAllModal}
                    onClose={clearAllCancelHandler}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    style={{ top: '40%' }}
                    data-testid="clearAll-modal"
                    className={styles.modal}
                >
                    <Box
                        className={styles.modalUnpin}
                        sx={{ background: 'white', width: '100%', padding: '10px', borderRadius: '8px' }}
                    >
                        <h4 id="child-modal-title" style={{ fontWeight: 'bold' }}>
                            {t('confirmUnpinning')}
                        </h4>
                        <hr style={{ width: '100%', height: '1px' }}></hr>
                        <div id="child-modal-description" className={styles.description}>
                            <p id="child-modal-description">{t('unPinningPrompt')}</p>
                        </div>
                        <hr style={{ width: '100%', height: '1px' }}></hr>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                data-testid="my-clearAll-cancel"
                                className={styles.clearAllCancel}
                                onClick={clearAllCancelHandler}
                            >
                                {t('cancel')}
                            </Button>
                            <Button
                                data-testid="my-clearAll-button"
                                variant="contained"
                                className={styles.clearAllButton}
                                onClick={clearAllHandler}
                            >
                                {t('yes')}
                            </Button>
                        </div>
                    </Box>
                </Modal>
            )}
        </React.Fragment>
    );
};
export default LeftPanel;
